import { gql } from 'apollo-angular'

export const GET_ARTICLE_ID_BY_SENEID = gql`
  query getArticleIdBySeneId($seneArticleId: Float!) {
    Articles(select: true, where: { sene_id: { equals: $seneArticleId } }) {
      docs {
        id
      }
    }
  }
`
